import React from 'react';
import { styled, keyframes } from '@mui/material/styles';
import { Container } from '@mui/material';
import LanguageSelector from './LanguageSelector';

// Создаем анимацию вращения
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// Обновленная иконка глобуса с анимацией
const GlobeIcon = styled('svg')({
  width: '28px',
  height: '28px',
  animation: `${rotate} 5s linear infinite`, // Медленное постоянное вращение
  marginRight: '4px',
});

const Globe = () => (
  <GlobeIcon viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
  </GlobeIcon>
);

const HeaderWrapper = styled('header')({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1000,
  background: 'linear-gradient(45deg,hsla(191, 100%, 50%, 0.7),hsla(177, 65%, 30%, 0.7))',
  backdropFilter: 'blur(7px)',
  borderBottomLeftRadius: '24px',
  borderBottomRightRadius: '24px',
  boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
});

const HeaderContent = styled(Container)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 24px',
});

const LogoWrapper = styled('div')({
  background: 'rgba(255, 255, 255, 0.05)',
  backdropFilter: 'blur(15px)',
  borderRadius: '12px',
  padding: '0px 15px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px solid rgba(255, 255, 255, 0.1)',
});

const Logo = styled('div')({
  color: '#fff',
  fontSize: '1.7rem',
  fontWeight: 600,
  letterSpacing: '-0.02em',
  cursor: 'default',
  transition: 'all 0.3s ease',
  fontFamily: "'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif",
  display: 'flex',
  alignItems: 'center',
  userSelect: 'none',
  '& span': {
    display: 'inline-block',
    transform: 'translateY(-2px)',
  },
});

interface HeaderProps {
  currentLang: 'en' | 'ru' | 'th';
  onChangeLang: (lang: 'en' | 'ru' | 'th') => void;
}

const Header: React.FC<HeaderProps> = ({ currentLang, onChangeLang }) => {
  return (
    <HeaderWrapper>
      <HeaderContent maxWidth="lg">
        <LogoWrapper>
          <Logo>
            <Globe />
            <span>bubnov</span>
          </Logo>
        </LogoWrapper>
        <LanguageSelector currentLang={currentLang} onChangeLang={onChangeLang} />
      </HeaderContent>
    </HeaderWrapper>
  );
};

export default Header; 